import styled from 'styled-components';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Login from './pages/Login/Login';
import Employee from "./pages/Employees/EmployeeList";
import Inventory from "./pages/Inventory/InventoryList";
import Barcode from "./pages/Barcode/Barcode";
import { Helmet } from "react-helmet";
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import RoleBasedRoute from './components/RoleBasedRoute';
import StockKeeperDashboard from './pages/stock-keeper-dashbaord/Dashboard';
import SupervisorDashboard from './pages/supervisor-dashboard/SupervisorDashboard';
import CashierDashboard from './components/CashierDashboard';
import CashierSidebar from './components/CashierSidebar';
import { setupAxiosInterceptors, isStockKeeper, isCashier } from './services/authService';

import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

function App() {
    const [currentPage, setCurrentPage] = useState("Dashboard");
    const [stockKeeperPage, setStockKeeperPage] = useState("Inventory");
    const [cashierPage, setCashierPage] = useState("Invoice");
    const [supervisorPage, setsupervisorPage] = useState("Dashboard");

    // Set up Axios interceptors on app load
    useEffect(() => {
        setupAxiosInterceptors();
    }, []);

    return (
        <AuthProvider>
            <Router>
                {/* Set Page Title and Favicon */}
                <Helmet>
                    <title>Thomas and Sons</title>
                    <link rel="icon" type="image/png" href="/logo.png" />
                </Helmet>

                <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<Login />} />

                    {/* Public Barcode Routes */}
                    <Route path="/barcode" element={<Barcode />} />

                    {/* Role selector route - decides which dashboard to show */}
                    <Route path="/role-select" element={<RoleBasedRoute />} />

                    {/* Protected Routes */}
                    <Route element={<ProtectedRoute />}>
                        {/* Stock Keeper Dashboard */}
                        <Route path="/stock-dashboard" element={
                            <Div>
                                {/*<StockKeeperSidebar setCurrentPage={setStockKeeperPage} />*/}
                                <StockKeeperDashboard currentPage={stockKeeperPage} />
                            </Div>
                        } />

                        {/* Cashier Dashboard */}
                        <Route path="/cashier-dashboard" element={
                            <Div>
                                <CashierSidebar setCurrentPage={setCashierPage} />
                                <CashierDashboard currentPage={cashierPage} />
                            </Div>
                        } />
                        {/* Supervisor Dashboard */}
                        <Route path="/supervisor-dashboard" element={
                            <Div>
                                {/*<StockKeeperSidebar setCurrentPage={setStockKeeperPage} />*/}
                                <SupervisorDashboard currentPage={supervisorPage} />
                            </Div>
                        } />
                        {/* Regular Dashboard for admin users */}
                        <Route path="/dashboard" element={
                            <Div>
                                <Sidebar setCurrentPage={setCurrentPage} />
                                <Dashboard currentPage={currentPage} />
                            </Div>
                        } />

                        {/* These routes should check role before allowing access */}
                        <Route path="/employees" element={
                            isStockKeeper() ?
                                <Navigate to="/stock-dashboard" replace /> :
                                isCashier() ?
                                    <Navigate to="/cashier-dashboard" replace /> :
                                    <Employee />
                        } />

                        {/* Inventory is accessible by admins and stock keepers but not cashiers */}
                        <Route path="/inventory" element={
                            isCashier() ?
                                <Navigate to="/cashier-dashboard" replace /> :
                                <Inventory />
                        } />

                        {/* Redirect root to role selection */}
                        <Route path="/" element={<Navigate to="/role-select" replace />} />
                    </Route>

                    {/* Catch-all route - redirect to login or dashboard based on authentication */}
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;

const Div = styled.div`
    position: relative;
`;